module.exports = __webpack_public_path__ + "img/zh_xdcj.bea272ef.svg";